/**
 * functionality for incrementing post views
 */
function vzAjaxPostView() {
  let postId = 0;

  document.body.classList.forEach(
      function(value) {
        const search = 'postid-';
        if (value.indexOf(search) == 0) {
          postId = value.substr(7); // len('postid-')
        }
      }
  );

  if ( ! document.body.classList.contains('single') || ! postId ) return;

  jQuery.ajax({
    url: vz_ajax.ajaxurl,
    type: 'POST',
    dataType: 'html',
    timeout: 8000,
    data: {
      action: 'postviews',
      id: postId,
      security: vz_ajax.postview_nonce,
    }
  });
}
